import api from '@/api'
import moment from 'moment'
import { Message } from 'element-ui'
import {getCvPortrait} from "@/api/list/cvsV3";
let checkTimer = null

const actions = {
	// 获取下载机构号入口数据
  getGroupsEntry: async ({commit}) => {
    try {
      let params = {
        type: 'download'
      }
      let res = await api.account.getUserEntrance(params)
      commit('setGroupsEntryData', res)
    }catch (e) {
      console.log(e)
    }
  },
	// 获取简历画像
	getCvPortrait: async ({commit}, cvToken) => {
		try {
			let res = await api.cvsV3.getCvPortrait(cvToken)
			if (res.code === 1000) {
				let { skills, highlights, risks } = res.data
				let cv_highlights = []
				let cv_risks = []
				Object.keys(highlights).forEach((item, index) => {
					if (item !== 'skill' && highlights[item].trim().length) {
						cv_highlights.push(highlights[item])
					}
				})
				Object.keys(risks).forEach((item, index) => {
					if (typeof risks[item] !== 'object' && risks[item].trim().length) {
						cv_risks.push(risks[item])
					}
				})
				if (risks.edu_abnormal && risks.edu_abnormal.length) cv_risks.push(...risks.edu_abnormal)
				if (risks.work_break && risks.work_break.length) cv_risks.push(...risks.work_break)
				commit('setCvPortrait', {skills, cv_highlights, cv_risks})
			}
		} catch (e) {
			console.error(e)
		}
	},
  // 获取 jobscan 报告数据
  getReport: async ({commit}, cvToken) => {
    try {
      let res = await api.jobs.getBriefReport({cv_token: cvToken})
      if(res.code === 1000){
        commit('setIsShowJobscanGuide', false)
        commit('setHasJobscanRepor', true)
        commit('setJobscanResultData', res.data)
      }else{
        commit('setHasJobscanRepor', false)
      }
    }catch (e) {
      console.error("获取简易报告异常",e)
      return res
    }
  },
	//获取cv信息
	getCvDetail: async ({ commit, rootState, state }, query) => {
		try {
			let token, cv_account_token = ''
			if(typeof query === 'string'){
				token = query
			}else {
				cv_account_token = query.cv_account_token
				token = query.token
			}
			let res = {}
			if (window.location.href.includes('mentor')) {
				res = await api.cvsEditor.getMentorCvInfo(token)
			} else {
				res = await api.cvsEditor.getCvInfo(token, {})
			}
			if (res.code === 1000) {
				let { basic_info, submodule_info } = res.data
				if (basic_info.kind === 'template') {
					basic_info.created_at = null
					basic_info.updated_at = null
				}
				let { submodule_info: { sections_position, extras_position } } = res.data
				let new_extras_position = extras_position.concat([ 'skills', 'certificates', 'languages', 'interests', 'others' ])
				//去重
				res.data.submodule_info.extras_position = Array.from(new Set(new_extras_position))

				//保存行距
				commit('setOldLineHeight', res.data.format_info.line_spacing)

				commit('setCvDetail', res.data)
				//设置备份的简历设置信息
				await commit('setBackUpFormatInfo', JSON.parse(JSON.stringify(res.data.format_info)))
				if(cv_account_token) {
					let res1 = await api.cvsEditor.getIsFirstCv({cv_account_token})
					if(res1.code === 1000 && res1.data.is_first){
						commit('setIsFirstCvInfo', {
							isFirst: true,
							data: res1.data.temp_match
						})
					}else {
						commit('setIsFirstCvInfo', {
							isFirst: false,
							data: {}
						})
					}
				}
				return res
			} else {
				return res
			}
		} catch (error) {
			return res
			// console.log('getCvDetail=>error=>>>', error)
		}
	},
	// 创建cv信息
	createCvDetail: async ({ commit }, { payload, dontReload, displayLoading = true }) => {
		try {
			payload.basic_info.source_cv_token = payload.basic_info.token
			payload.basic_info.sample_cv_source_token = payload.basic_info.token // 记录创建简历的来源“大牛简历”或者“八大模板”
			payload.basic_info.token = null
			payload.basic_info.kind = null
			commit('setIsSendRequest', true)
			let res = await api.cvsEditor.createCv(payload)
			if (res.code === 1000) {
				commit('setCvDetail', res.data)
				Message.closeAll()
				if (displayLoading) {
					Message.success('保存成功')
				}
				// 动态修改url
				let newUrl = `${ window.location.origin }/cvs/${ res.data.basic_info.token }/editor`
				window.history.replaceState({}, 0, newUrl)
				if (!dontReload) {
					setTimeout(() => {
						window.location.reload()
					}, 300)
				}
				commit('setIsSendRequest', false)
			} else {
				commit('setIsSendRequest', false)
				Message.closeAll()
				Message.error('保存失败')
			}
			return res
		} catch (e) {
			commit('setIsSendRequest', false)
			Message.closeAll()
			Message.error('保存失败，请重试')
			console.log(e)
		}
	},
	// 更新cv信息
	updateCvDetail: async ({ commit, state, rootState, dispatch }, payload) => {
		try {
			let res = {}
			let { basic_info: { token } } = state.cvDetail
			commit('setIsSendRequest', true)
			const { skipCheck, ...rest } = payload
			if (window.location.href.includes('mentor')) {
				res = await api.cvsEditor.updatedMentorCvInfo(token, rest)
			} else {
				res = await api.cvsEditor.updatedCvInfo(token, rest)
			}
			if (res.code === 1000) {
				let data = {
					...state.cvDetail,
					...res.data
				}
				data.basic_info.updated_at = moment().format('YYYY-MM-DD HH:mm:ss');
				// if (state.saveFormDataByDialog) {
				// 	state.saveFormDataByDialog()
				// 	commit('setFormDataFn', null)
				// }
				commit('setCvDetail', data)
				if (rest.operation_type !== 'update_format_info')  Message.closeAll() // 一页纸之后的的toast不关闭
				if (rest.saveModule && !state.openResumeError) Message.success('保存成功')
				if (!skipCheck) {
					setTimeout(() => {
						dispatch('getCheckData', { needDealCheck: !rootState.me.isMembership, needScoreChange: false })
					}, 30)
				}
				commit('setIsSendRequest', false)
				return res
			} else {
				commit('setIsSendRequest', false)
				if (rest&&rest.not_need_default_error_tips) {
					// 1、产品要求自定义错误消息，我很无奈，如果要改的话改动太大
					// 2、只能在payload里面加个参数来标识 不需要默认的错误提示消息，
				} else {
					Message.closeAll()
					Message.error('保存失败，请重试')
				}
			}
			return res
		} catch (e) {
			Message.closeAll()
			Message.error('保存失败，请重试')
			commit('setIsSendRequest', false)
			console.log(e)
		}
	},
	// 获取简历的数据
	getCvInfoData: async ({ state, dispatch, rootState }, { check, only_desc }) => {
		let { submodule_info, basic_info: { lang, token, kind } } = state.cvDetail
		let { sections_position } = submodule_info
		// const p = new Promise(resolve => {
		let requestList = []
		if (!window.location.href.includes('mentor')) {
			requestList.push(dispatch('getProfileData', 'getProfile'))
		} else {
    	requestList.push(dispatch('getProfileData', 'getMentorProfile'))
    }
		sections_position.forEach(item => {
			if (item.id) {
				if (item.info_ids.length) requestList.push(dispatch('getCustomExperience', {
					id: item.id,
					payload: { info_ids: item.info_ids.join(), only_desc: false },
					type: item.type,
				}))
			} else if (item.type === 'extras') {
				requestList.push(dispatch('getExtrasExperience', {
					skill_id: submodule_info.skill_id,
					language_id: submodule_info.language_id,
					certificate_id: submodule_info.certificate_id,
					other_id: submodule_info.other_id,
					interest_id: submodule_info.interest_id
				}))
			} else if (submodule_info[`${ item.type }_ids`].length) {
				requestList.push(
					dispatch('getExperience', {
						type: item.type,
						payload: { ids: submodule_info[`${ item.type }_ids`].join(), lang, only_desc }
					}))
			}
		})
		// 	resolve()
		// })
		await Promise.all(requestList)
		if (check) dispatch('getCheckData', { needDealCheck: !rootState.me.isMembership })
		// console.log(state)
	},
	// 获取基本信息数据
	getProfileData: async ({ commit, state }, func) => {
		try {
			let { basic_info: { token, kind, mentor_id } } = state.cvDetail
			let res = await api.cvsEditor[func](token, {
				cv_kind: kind === 'template' || kind === 'sample' ? `${ kind }` : null,
			})
			if (res.code === 1000) {
				let { profile } = res.data
				if (profile.kind === 'template' || profile.kind === 'sample') {
					delete profile.id
					profile.kind = null
				}
				if (profile.birthday) {
					profile.birthday = profile.birthday.substring(0, 7)
				}
				profile.format_pref = (profile.format_pref && Object.keys(profile.format_pref).length) ? profile.format_pref : {
					age_birthday: {
						chosen: 'birthday',
						date_format: 'yyyy_d'
					}
				}
				if (!profile.format_pref.age_birthday) {
					profile.format_pref.age_birthday = {
						chosen: 'birthday',
						date_format: 'yyyy_d'
					}
				}

				commit('setProfileData', res.data.profile)
				// set profile 备份数据
				commit('setBackUpProfile', JSON.parse(JSON.stringify(res.data.profile)))

			}
			return res
		} catch (e) {
			console.log(e)
		}
	},
	// 创建基本信息模块
	createProfileData: async ({ commit, state, dispatch }, { payload, dontReload, displayLoading = true, skipCheck = false }) => {
		try {
			if (state.isSendRequest) {
				return {}
			}
			let { basic_info: { token } } = state.cvDetail
			if (payload.birthday) {
				payload.birthday += '-01'
			}
			if (displayLoading) {
				Message({
					type: 'info',
					iconClass: 'el-icon-loading',
					message: '保存中',
					duration: 0
				})
			}
			commit('setIsSendRequest', true)
			let res = await api.cvsEditor.createProfile(token, payload)
			if (res.code === 1000) {
				commit('setProfileData', res.data.profile)
				dispatch('updateCvDetail', { operation_type: 'touch', skipCheck })
				Message.closeAll()
				Message.success('保存成功')
				commit('setIsSendRequest', false)
				// if(!dontReload){
				// 	window.location.reload();
				// }
			} else {
				Message.closeAll()
				commit('setIsSendRequest', false)
				Message.error('保存失败，请重试')
			}
			return res
		} catch (e) {
			Message.closeAll()
			commit('setIsSendRequest', false)
			Message.error('保存失败，请重试')
			console.log(e)
		}
	},
	// 更新基本信息模块
	updateProfileData: async ({ commit, state, dispatch }, { payload, displayLoading = true, skipCheck = false }) => {
		try {
			if (state.isSendRequest) {
				return {}
			}
			let { basic_info: { token } } = state.cvDetail
			payload.is_mentor = window.location.href.includes('mentor')
			if (payload.birthday && payload.birthday.length <= 7) {
				payload.birthday += '-01'
			}
			if (displayLoading) {
				// Message({
				// 	type: 'info',
				// 	iconClass: 'el-icon-loading',
				// 	message: '保存中',
				// 	duration: 0
				// })
			}
			commit('setIsSendRequest', true)
			let res = await api.cvsEditor.editProfile(token, payload)
			if (res.code === 1000) {
				commit('setIsSendRequest', false)
				commit('setProfileData', res.data.profile)
				dispatch('updateCvDetail', { operation_type: 'touch', skipCheck })
			} else {
				commit('setIsSendRequest', false)
				Message.closeAll()
				Message.error('保存失败，请重试')
			}
			return res
		} catch (e) {
			commit('setIsSendRequest', false)
			Message.closeAll()
			Message.error('保存失败，请重试')
			console.log(e)
		}
	},
	// 更新基本信息模块(付费信息)
	updateVipProfileData: async ({ commit, state, dispatch }, { payload, profile, displayLoading = true, skipCheck = false }) => {
		try {
			if (state.isSendRequest) {
				return {}
			}
			let { basic_info: { token } } = state.cvDetail

			if (displayLoading) {
				Message({
					type: 'info',
					iconClass: 'el-icon-loading',
					message: '保存中',
					duration: 0
				})
			}

			commit('setIsSendRequest', true)
			let res = await api.cvsEditor.updateVipProfile(token, payload)
			if (res.code === 1000) {
				commit('setIsSendRequest', false)
				commit('setProfileData', profile)
				dispatch('updateCvDetail', { operation_type: 'touch', skipCheck })
			} else {
				commit('setIsSendRequest', false)
				Message.closeAll()
				// Message.error('保存失败，请重试')
			}
			return res
		} catch (e) {
			commit('setIsSendRequest', false)
			Message.closeAll()
			Message.error('保存失败，请重试')
			console.log(e)
		}
	},
	// 获取 work edu org opus 经历数据
	getExperience: async ({ commit, state }, { type, payload }) => {
		try {
			let { basic_info: { mentor_id, kind } } = state.cvDetail
			let method = ''
			if(type === 'edus'){
				method = 'getEdusList'
			}else if(type === 'orgs'){
				method = 'getOrgsList'
			}else if(type === 'opus'){
				method = 'getOpusList'
			}else {
				method = 'getWorksList'
			}
			if (window.location.href.includes('mentor')) {
				payload.type = 'mentor'
			}
			let res = await api.cvsEditor[method](payload)
			if (res.code === 1000) {
				commit('setModuleData', { type, info: res.data[type] })
			}
		} catch (e) {
			console.log(e)
		}
	},
	// 更新 work edu org opus 的经历
	updateExperience: async ({ commit, state }, { type, payload, displayLoading = true }) => {
		try {
			if (state.isSendRequest) {
				return {}
			}
			let method = ''
			if(type === 'edus'){
				method = 'editEdu'
			}else if(type === 'orgs'){
				method = 'editOrg'
			}else if(type === 'opus'){
				method = 'editOpus'
			}else {
				method = 'editWork'
			}

			payload.is_mentor = window.location.href.includes('mentor')
			if(type !== 'opus'){
				payload.start_at = payload.start_at ? moment.utc(payload.start_at) : null
				payload.end_at = payload.end_at ? moment.utc(payload.end_at) : null
			}

			if (displayLoading) {
				Message({
					type: 'info',
					iconClass: 'el-icon-loading',
					message: state.openResumeError ? '修改中' : '保存中',
					duration: 0
				})
			}

			commit('setIsSendRequest', true)
			let res = await api.cvsEditor[method](payload.id, payload)
			if (res.code === 1000) {
				commit('setIsSendRequest', false)
			} else {
				commit('setIsSendRequest', false)
				Message.closeAll()
				Message.error('保存失败，请重试')
			}
			return res
		} catch (e) {
			commit('setIsSendRequest', false)
			Message.closeAll()
			Message.error('保存失败，请重试')
			console.log(e)
		} finally {
			Message.closeAll()
		}
	},
	// 创建 work，edu，org, opus 经历
	createExperience: async ({ state, commit }, { type, payload, displayLoading = true }) => {
		if (state.isSendRequest) {
			return {}
		}
		let { mentor_id } = state.cvDetail.basic_info
		try {
			// const method = type === 'edus' ? 'createEdu' : type === 'orgs' ? 'createOrg' : 'createWork'
			let method = ''
			if(type === 'edus'){
				method = 'createEdu'
			}else if(type === 'orgs'){
				method = 'createOrg'
			}else if(type === 'opus'){
				method = 'createOpus'
			}else {
				method = 'createWork'
			}
			if(type !== 'opus'){
				payload.start_at = payload.start_at ? moment.utc(payload.start_at) : null
				payload.end_at = payload.end_at ? moment.utc(payload.end_at) : null
			}
			if (mentor_id) {
				payload.cv_token = state.cvToken
			}
			if (displayLoading) {
				Message({
					type: 'info',
					iconClass: 'el-icon-loading',
					message: '保存中',
					duration: 0
				})
			}
			commit('setIsSendRequest', true)
			let res = await api.cvsEditor[method](payload)
			if (res.code === 1000) {
				commit('setIsSendRequest', false)
				// Message.closeAll()
				// Message.success('保存成功')
				// commit('setModuleData', { type, info: res.data[type] })
			} else {
				commit('setIsSendRequest', false)
				Message.closeAll()
				Message.error('保存失败，请重试')
			}
			return res
		} catch (e) {
			commit('setIsSendRequest', false)
			Message.closeAll()
			Message.error('保存失败，请重试')
			console.log(e)
		} finally {
			Message.closeAll()
		}
	},
	// 获取自定义模块的数据
	getCustomExperience: async ({ commit, state }, { id, payload, type }) => {
		try {
			let { basic_info: { mentor_id, kind } } = state.cvDetail
			if (window.location.href.includes('mentor')) {
				payload.type = 'mentor'
			}
			let res = await api.cvsEditor.getCustomInfoList(id, payload)
			if (res.code === 1000) {
				let sectionType = type === 'custom' ? id : type
				commit('setModuleData', { type: sectionType, info: res.data.infos })
				commit('setModuleKind', { id, kind: res.data.kind })
			}
		} catch (e) {
			console.log(e)
		}
	},
	// 创建自定义模块
	createCustom: async function ({ commit, state }, payload) {
		if (state.isSendRequest) {
			return {}
		}

		const displayLoading = payload.displayLoading ?? true
		delete payload.displayLoading

		let { mentor_id } = state.cvDetail.basic_info
		try {
			if (mentor_id) {
				payload.cv_token = state.cvToken
			}
			if (displayLoading) {
				Message({
					type: 'info',
					iconClass: 'el-icon-loading',
					message: '保存中',
					duration: 0
				})
			}
			commit('setIsSendRequest', true)
			let res =  await api.cvsEditor.createCustom(payload)
			if (res.code === 1000) {
				commit('setIsSendRequest', false)
				// Message.closeAll()
				// Message.success('保存成功')
				// commit('setModuleData', { type, info: res.data[type] })
			} else {
				commit('setIsSendRequest', false)
				Message.closeAll()
				Message.error('保存失败，请重试')
			}
			return res
		} catch (e) {
			commit('setIsSendRequest', false)
			Message.closeAll()
			Message.error('保存失败，请重试')
			console.log(e)
		}
	},
	// 创建自定义模块info
	createCustomInfo: async function ({ state, commit }, { id, payload, displayLoading = true }) {
		if (state.isSendRequest) {
			return {}
		}
		let { mentor_id } = state.cvDetail.basic_info
		try {
			if (mentor_id) {
				payload.cv_token = state.cvToken
			}
			if (displayLoading) {
				Message({
					type: 'info',
					iconClass: 'el-icon-loading',
					message: '保存中',
					duration: 0
				})
			}
			commit('setIsSendRequest', true)
			let res = await api.cvsEditor.createCustomInfo(id, payload)
			if (res.code === 1000) {
				commit('setIsSendRequest', false)
				// Message.closeAll()
				// Message.success('保存成功')
				// commit('setModuleData', { type, info: res.data[type] })
			} else {
				commit('setIsSendRequest', false)
				Message.error('保存失败，请重试')
			}
			return res
		} catch (e) {
			commit('setIsSendRequest', false)
			Message.error('保存失败，请重试')
			console.log(e)
		}
	},
	// 更新自定义模块的info
	updateCustomInfo: async function ({ commit, state }, payload) {
		try {
			if (state.isSendRequest) {
				return {}
			}
			payload.is_mentor = window.location.href.includes('mentor')

			const displayLoading = payload.displayLoading ?? true
			delete payload.displayLoading

			if (displayLoading) {
				Message({
					type: 'info',
					iconClass: 'el-icon-loading',
					message: state.openResumeError ? '修改中' : '保存中',
					duration: 0
				})
			}
			commit('setIsSendRequest', true)
			let res = await api.cvsEditor.editCustomInfo(payload.custom_section_id, payload.id, payload)
			if (res.code === 1000) {
				commit('setIsSendRequest', false)
				// Message.closeAll()
				// Message.success('保存成功')
				// commit('setModuleData', { type, info: res.data[type] })
			} else {
				commit('setIsSendRequest', false)
				Message.closeAll()
				Message.error('保存失败，请重试')
			}
			return res
		} catch (e) {
			commit('setIsSendRequest', false)
			Message.closeAll()
			Message.error('保存失败，请重试')
			console.log(e)
		}
	},
	// 获取extras数据
	getExtrasExperience: async ({ commit, state }, payload) => {
		try {
			let { basic_info: { mentor_id, kind } } = state.cvDetail
			if (window.location.href.includes('mentor')) {
				payload.type = 'mentor'
			}
			let res = await api.cvsEditor.getExtrasList(payload)
			if (res.code === 1000) {
				for (const key in res.data.others) {
					res.data.others[key].id = res.data.others[key].id || null;
					res.data.others[key].description = res.data.others[key].description || '';
				}
				commit('setExtrasData', res.data.others)
			}
		} catch (e) {
			console.log(e)
		}
	},
	// 创建其他/技能模块
	createExtra: async function ({ commit, state }, payload) {
		if (state.isSendRequest) {
			return {}
		}

		const displayLoading = payload.displayLoading ?? true
		delete payload.displayLoading

		let { mentor_id } = state.cvDetail.basic_info
		try {
			if (mentor_id) {
				payload.cv_token = state.cvToken
			}
			if (displayLoading) {
				Message({
					type: 'info',
					iconClass: 'el-icon-loading',
					message: '保存中',
					duration: 0
				})
			}
			commit('setIsSendRequest', true)
			let res = await api.cvsEditor.createExtra(payload)
			if (res.code === 1000) {
				// Message.closeAll()
				commit('setIsSendRequest', false)
				// Message.success('保存成功')
				// commit('setModuleData', { type, info: res.data[type] })
			} else {
				Message.closeAll()
				commit('setIsSendRequest', false)
				Message.error('保存失败，请重试')
			}
			return res
			// if (res.code === 1000) {
			// 	commit('setExtrasData', res.data.others)
			// }
		} catch (e) {
			commit('setIsSendRequest', false)
			Message.closeAll()
			Message.error('保存失败，请重试')
			console.log(e)
		}
	},
	// 更新模块
	updateExtra: async function ({ commit, state }, payload) {
		try {
			if (state.isSendRequest) {
				return {}
			}

			const displayLoading = payload.displayLoading ?? true
			delete payload.displayLoading

			payload.is_mentor = window.location.href.includes('mentor')
			if (displayLoading) {
				Message({
					type: 'info',
					iconClass: 'el-icon-loading',
					message: '保存中',
					duration: 0
				})
			}
			commit('setIsSendRequest', true)
			let res = await api.cvsEditor.editExtra(payload)
			if (res.code === 1000) {
				commit('setIsSendRequest', false)
				// Message.closeAll()
				// Message.success('保存成功')
				// commit('setModuleData', { type, info: res.data[type] })
			} else {
				commit('setIsSendRequest', false)
				Message.closeAll()
				Message.error('保存失败，请重试')
			}
			return res
			// if (res.code === 1000) {
			// 	commit('setExtrasData', res.data.others)
			// }
		} catch (e) {
			commit('setIsSendRequest', false)
			Message.closeAll()
			Message.error('保存失败，请重试')
			console.log(e)
		} finally {
			Message.closeAll()
		}
	},
	// 获取 check 的信息
	getCheckData: async function ({ state, commit, rootState }, { needDealCheck, clickCheck, needScoreChange = true }) {
		let res = {}
		try {
			let custom_sections = []
			let { submodule_info: { sections_position }, basic_info: { token } } = state.cvDetail
			sections_position.forEach(item => {
				if (item.id) {
					let module = {
						id: item.id,
						infos: state[item.type] || state[item.id] || [],
						section: item.type
					}
					custom_sections.push(module)
				}
			})
			let payload = {
				cv_token: token,
				cv: {
					...state.cvDetail,
					profile: state.profile,
					edus: state.edus,
					orgs: state.orgs,
					works: state.works,
					others: state.extras,
					custom_sections,
				}
			}
			if (clickCheck) {
				commit('setScannerState', true)
				payload.manual = 1
				payload.active = 1
			}
			// console.log(payload,"========================>payload")
			res = await api.cvsEditor.cvChecks(payload)
			// console.log(res,"=====================>resssss")
			if (res.code === 1000) {
				let oldCheckData = localStorage.getItem(`${ state.cvDetail.basic_info.token }-checkData`)
				if (!rootState.me.isMembership && !oldCheckData) localStorage.setItem(`${ state.cvDetail.basic_info.token }-checkData`, JSON.stringify(res.data.suggestions))
				const fn = () => {
					commit('setSyncData', res.data.sync_is_success)
					commit('setScore', res.data.score)
					if (needDealCheck) commit('setDealCheck', true)
					if (needScoreChange) {
						let score = 0
						checkTimer = setInterval(() => {
							if (score === res.data.score) {
								clearInterval(checkTimer)
							} else {
								score += 1
							}
							commit('setCheckData', { ...res.data, score })
						}, 10)
					} else {
						commit('setCheckData', res.data)
					}
				}
				if (clickCheck) {
					setTimeout(() => {
						commit('setScannerState', false)
						fn()
					}, 2000)
				} else {
					fn()
				}
			} else {
				setTimeout(() => {
					commit('setScannerState', false)
				}, 2000)
			}
		} catch (e) {
			setTimeout(() => {
				commit('setScannerState', false)
			}, 2000)
			console.log(e)
		}
		return res
	},
	// 自动排序
	cvAutoSort: async function ({ commit, state }, save) {
		try {
			let cvData = {
				cv: state.cvDetail,
				save,
			}
			let is_mentor = window.location.href.includes('mentor')
			let { submodule_info: { sections_position }, basic_info: { token } } = state.cvDetail
			sections_position.forEach(item => {
				if (item.type === 'custom') {
					cvData[item.id] = state[item.id]
				} else {
					cvData[item.type] = state[item.type]
				}
			})
			let res = await api.cvsEditor.autoSort(token, cvData, is_mentor)
			if (res.code === 1000) {
				let { data } = res
				for (let key in data) {
					if (key === 'cv') {
						commit('setCvDetail', data.cv)
					} else if (key !== 'save') {
						commit('setModuleDataBySort', { type: key, infos: data[key] })
					}
				}
				Message.success('已将经历按照时间倒序排列')
      // 简历未创建
			} else if (res.code === 80120) {
				Message.success('已将经历按照时间倒序排列')
      } else {
				Message.error('服务器开小差了，请稍后再试')
			}
		} catch (e) {
			Message.error('服务器开小差了，请稍后再试')
			console.log(e)
		}
	},
	// 获取Faq
	getFaqOption: async function ({ dispatch, state, commit }, cvToken) {
		let { cvDetail } = state
		let params = {
			cv_type: cvDetail.basic_info.cv_type,
			type: 'faqs'
		}
		let res = await api.cvsEditor.getFaqOptions(params)
		if (res.code !== 1000) {
			return res
		}
		let { faq_options } = res.data
		commit('setFaqOptions', faq_options)
		return res
	},
	// 获取案例，动词，小贴士
	getAssistInfo: async function ({ commit, state }, { payload, type }) {
		try {
			let { basic_info: { lang, token } } = state.cvDetail
			let moduleType = state.currentInfo.type
			if (moduleType === 'works' && lang === 'cn' && type === 'examples') {
				let res = await api.cvsEditor.getWorkExamples(token, payload)
				if (res.code === 1000) {
					commit('setAssistInfo', { type, info: res.data })
				}
			} else {
				if (type === 'examples') payload.lang = lang
				let res = await api.cvsEditor.getAssistInfo(payload)
				if (res.code === 1000) {
					commit('setAssistInfo', { type, info: res.data })
				}
			}

		} catch (e) {
			console.log(e)
		}
	},
	//获取职位的id
	getPostLevelId: async ({ commit, state},  payload ) => {
			try {
				if(!state.postId){
					let res = await api.cvsEditor.getPostLevelId(payload)
					if(res.code === 1000){
						commit('setPostId', res.data.level3_ids[0] || res.data.level2_ids[0] || res.data.level1_ids[0])
					} else {
						commit('setPostId', '')
					}
				}
			}catch (e) {
				console.log(e,'获取职位异常')
			}
	},
	//获取自动书写的内容
	getAutoResumeWriteList: async ({ commit ,state , dispatch }, payload) => {
		try {
			commit('setAutoTransition',false)
			commit('setAutoLoading',true)
			if(!state.postId){
				await dispatch('getPostLevelId', {job_title: payload.job_title})
			}
			let res = await api.cvsEditor.getAutoWriteList(payload)
			if(res.code === 1000){
				commit('setAutoWriteList', res.data.sentences)
				commit('setAutoWriteTotal', res.data.count)
			} else {
				commit('setAutoWriteList', [])
				commit('setAutoWriteTotal', 0)
			}
			commit('setAutoLoading',false)
			commit('setAutoTransition',true)
		}catch (e) {
			console.log("获取内容出现了异常",e)
		}
	},
	// 整理cv信息
	getFormatCvInfo: ({ commit ,state , dispatch }, options)=> {
		let custom_sections = []
		let { submodule_info: { sections_position }, basic_info: { token } } = state.cvDetail
		sections_position.forEach(item => {
			if (item.id) {
				let module = {
					id: item.id,
					infos: state[item.type] || state[item.id] || [],
					section: item.type
				}
				custom_sections.push(module)
			}
		})
		let payload = {
			cv_token: token,
			cv: {
				...state.cvDetail,
				profile: state.profile,
				edus: state.edus,
				orgs: state.orgs,
				works: state.works,
				others: state.extras,
				custom_sections,
			}
		}
		return payload
	}
}

export default actions
